export default __webpack_public_path__ + "7861683a2d5de3fe82f0a56140689393.svg";